require.register("app/ui/Editor", function(exports, require, module){
  $0
  
});

